import React from 'react';
import styled from 'styled-components';
import {media} from '../styles/breakpoints';

const HomeStepNumber = ({number}) => {
    const StyledHomeStepNumber = styled.div`
        border-radius: 50%;
        border: 2px dashed #444;
        background-color: white;
        color: #444;
        display: inline-block;
        font-size: ${props => props.theme.fontSizes[12]};
        position: relative;
        width: 100%;
        height: 0;
        padding: 45% 0;
        line-height: 0;
        text-align: center; 
     
        ${media.tweak600up`font-size:  ${props => props.theme.fontSizes[10]}`}
        
    `;

    return (
        <StyledHomeStepNumber>
            {number}
        </StyledHomeStepNumber>
    );
};

export default HomeStepNumber;



// WEBPACK FOOTER //
// ./src/components/home/HomeStepNumber.js